module.exports = __webpack_public_path__ + "static/media/raftReport.77ad6cc3.pdf";